import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTimeZoneTime',
})
export class GetTimeZoneTimePipe implements PipeTransform {
  transform(timeZone: string): string {
    if (typeof timeZone !== 'string' || !timeZone) {
      return null;
    }
    let time = new Date()
      .toLocaleDateString(undefined, {
        timeZoneName: 'short',
        timeZone: timeZone,
      })
      .split('GMT');
    if (time.length < 2) {
      // if the timezone wasn't like "GMT+X", return as is
      return timeZone;
    }
    time = time[1].split(':');
    const hours = time[0] || ' 00';
    const minutes = time[1] || '00';
    return `${timeZone} GMT${hours}:${minutes}`;
  }
}
